"use strict";
// https://github.com/ktknest/angular-pinch-zoom/blob/master/LICENSE

var isBuggyChrome = navigator.userAgent.match(/Chrom(?:e|ium)\/66\./);

angular.module('ngPinchZoom', [])
    /**
     * @ngdoc directive
     * @name ngPinchZoom
     * @restrict A
     * @scope false
     **/
    .directive('ngPinchZoom', ['$timeout', function($timeout) {
        function _link(scope, element, attrs) {
            var elWidth, elHeight;

            // mode : 'pinch' or 'swipe'
            var mode = '';

            // distance between two touche points (mode : 'pinch')
            var distance = 0;
            var initialDistance = 0;

            scope.ngPinchScale = 1;

            var relativeScale = 1;
            var initialScale = 1;
            var maxScale = parseInt(attrs.maxScale, 10);
            if (isNaN(maxScale) || maxScale <= 1) {
                maxScale = 3;
            }

            // position of the upper left corner of the element
            var positionX = 0;
            var positionY = 0;

            var initialPositionX = 0;
            var initialPositionY = 0;

            // central origin (mode : 'pinch')
            var originX = 0;
            var originY = 0;

            // start coordinate and amount of movement (mode : 'swipe')
            var startX = 0;
            var startY = 0;
            var moveX = 0;
            var moveY = 0;

            function updateElSize() {
                elWidth = element[0].clientWidth;
                elHeight = element[0].clientHeight;
            }

            if (isBuggyChrome) {
                element.css({
                    position: 'fixed'
                })
            }

            element.css({
                '-webkit-transform-origin': '0 0',
                'transform-origin': '0 0'
            });

            window.addEventListener('resize', updateElSize);

            element.on('touchstart', touchstartHandler);
            element.on('touchmove', touchmoveHandler);
            element.on('touchend', touchendHandler);

            element.on('$destroy', function() {
                window.removeEventListener('resize', updateElSize);
            });

            $timeout(function() {
                updateElSize();
            });

            /**
             * @param {object} evt
             */
            function touchstartHandler(evt) {
                var touches = evt.originalEvent ? evt.originalEvent.touches : evt.touches;

                startX = touches[0].clientX;
                startY = touches[0].clientY;
                initialPositionX = positionX;
                initialPositionY = positionY;
                moveX = 0;
                moveY = 0;
            }

            /**
             * @param {object} evt
             */
            function touchmoveHandler(evt) {
                var touches = evt.originalEvent ? evt.originalEvent.touches : evt.touches;

                if (mode === '') {
                    if (touches.length === 1 && scope.ngPinchScale > 1) {

                        mode = 'swipe';

                    } else if (touches.length === 2) {

                        mode = 'pinch';

                        initialScale = scope.ngPinchScale;
                        initialDistance = getDistance(touches);
                        if (angular.isUndefined(initialDistance)) {
                            return;
                        }
                        originX = touches[0].clientX -
                            parseInt((touches[0].clientX - touches[1].clientX) / 2, 10) -
                            element[0].offsetLeft - initialPositionX;
                        originY = touches[0].clientY -
                            parseInt((touches[0].clientY - touches[1].clientY) / 2, 10) -
                            element[0].offsetTop - initialPositionY;

                    }
                }

                if (mode === 'swipe') {
                    evt.preventDefault();

                    moveX = touches[0].clientX - startX;
                    moveY = touches[0].clientY - startY;

                    positionX = initialPositionX + moveX;
                    positionY = initialPositionY + moveY;

                    transformElement();

                } else if (mode === 'pinch') {
                    evt.preventDefault();

                    distance = getDistance(touches);
                    if (angular.isUndefined(distance)) {
                        return;
                    }
                    relativeScale = distance / initialDistance;
                    scope.ngPinchScale = relativeScale * initialScale;

                    positionX = originX * (1 - relativeScale) + initialPositionX + moveX;
                    positionY = originY * (1 - relativeScale) + initialPositionY + moveY;

                    transformElement();

                }
            }

            /**
             * @param {object} evt
             */
            function touchendHandler(evt) {
                var touches = evt.originalEvent ? evt.originalEvent.touches : evt.touches;

                if (mode === '' || touches.length > 0) {
                    return;
                }

                if (scope.ngPinchScale < 1) {

                    scope.ngPinchScale = 1;
                    positionX = 0;
                    positionY = 0;

                } else if (scope.ngPinchScale > maxScale) {

                    scope.ngPinchScale = maxScale;
                    relativeScale = scope.ngPinchScale / initialScale;
                    positionX = originX * (1 - relativeScale) + initialPositionX + moveX;
                    positionY = originY * (1 - relativeScale) + initialPositionY + moveY;

                    if (moveX >= 1 || moveY >= 1) {
                        evt.preventDefault();
                        evt.stopPropagation();
                    }

                } else {

                    if (positionX > 0) {
                        positionX = 0;
                    } else if (positionX < elWidth * (1 - scope.ngPinchScale)) {
                        positionX = elWidth * (1 - scope.ngPinchScale);
                    }
                    if (positionY > 0) {
                        positionY = 0;
                    } else if (positionY < elHeight * (1 - scope.ngPinchScale)) {
                        positionY = elHeight * (1 - scope.ngPinchScale);
                    }

                }

                transformElement(0.1);
                mode = '';
            }

            /**
             * @param {Array} touches
             * @return {Number|undefined}
             */
            function getDistance(touches) {
                try {
                    var d = Math.sqrt(Math.pow(touches[0].clientX - touches[1].clientX, 2) +
                        Math.pow(touches[0].clientY - touches[1].clientY, 2));
                    return parseInt(d, 10);
                } catch (e) {
                    return undefined;
                }
            }

            /**
             * @param {number} [duration]
             */
            function transformElement(duration) {
                var transition = duration ? 'all cubic-bezier(0,0,.5,1) ' + duration + 's' : '';
                var matrixArray = [scope.ngPinchScale, 0, 0, scope.ngPinchScale, positionX, positionY];
                var matrix = 'matrix(' + matrixArray.join(',') + ')';

                element.css({
                    '-webkit-transition': transition,
                    transition: transition,
                    '-webkit-transform': matrix + ' translate3d(0,0,0)',
                    transform: matrix
                });
            }
        }

        return {
            restrict: 'A',
            link: _link
        };
    }]);
